import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventarios',
  templateUrl: './inventarios.component.html',
  styleUrls: ['./inventarios.component.css']
})
export class InventariosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
